import KTripHistoryMap from "../maps/KTripHistoryMap";
import KBaseMapDialog from "@/components/Maps/KBaseMapDialog";
import { VCol, VSwitch } from "vuetify/lib";

export default KBaseMapDialog.extend( {
	name: "KTripHistoryMapDialog",

	props: { idTrip: Number },

	data: () => ( {
		trip: null
	} ),

	computed: {
		storeModuleName() {
			return `trip-history-map-${this.idTrip}`;
		},

		moduleRegistered() {
			return this.$store.state.hasOwnProperty( this.storeModuleName );
		},

		alerts: {
			get() {
				if ( this.moduleRegistered ) {
					return this.$store.state[this.storeModuleName].alerts;
				}

				return false;
			},

			set( val ) {
				if ( this.moduleRegistered ) {
					this.$store.dispatch( `${this.storeModuleName}/setAlerts`, val );
				}
			}
		},

		detailsSidebar: {
			get() {
				if ( this.moduleRegistered ) {
					return this.$store.state[this.storeModuleName].detailsSidebar;
				}

				return false;
			},

			set( val ) {
				if ( this.moduleRegistered ) {
					this.$store.dispatch( `${this.storeModuleName}/setDetailsSidebar`, val );
				}
			}
		},

		internalTitle() {
			if ( this.title ) {
				return this.title;
			} else if ( this.trip ) {
				return `Route Replay - ${this.trip.driverNames}, ${this.trip.truck.name}`;
			}

			return "Route Replay...";
		}
	},

	render() {
		return <KBaseMapDialog
			attrs={{
				...this.$props,
				title: this.internalTitle
			}}
			on={this.$listeners}
			scopedSlots={this.$scopedSlots}
		>
			<KTripHistoryMap
				idTrip={this.idTrip}
				storeModuleName={this.storeModuleName}
				onTripLoaded={trip => this.trip = trip}
			></KTripHistoryMap>

			<template slot="options">
				<VCol class="py-0">
					<VSwitch
						color="accent"
						inset
						label="Trip Details"
						prependIcon="list"
						vModel={this.detailsSidebar}
					></VSwitch>
				</VCol>

				<VCol class="py-0">
					<VSwitch
						color="accent"
						inset
						label="Truck Alerts"
						prependIcon="notifications"
						vModel={this.alerts}
					></VSwitch>
				</VCol>
			</template>
		</KBaseMapDialog>;
	}
} );
